import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const CTASection = ({ onOpenContactForm, heading, paragraph, buttonText, backgroundImage }) => {
  const section = useScrollAnimation({ threshold: 0.2 });

  return (
    <section data-testid="cta-section" ref={section.ref} className="relative py-20 md:py-24 overflow-hidden">
      {/* Abstract background image */}
      {backgroundImage && (
        <div className="absolute inset-0">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      {/* Red overlay */}
      <div className="absolute inset-0 bg-[#FF1010]/80 mix-blend-multiply" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className={`max-w-3xl mx-auto text-center scroll-fade-up ${section.isVisible ? 'scroll-visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tighter leading-tight mb-5 text-white uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {heading}
          </h2>
          <p className="text-base text-white/80 leading-relaxed mb-8 max-w-2xl mx-auto">
            {paragraph}
          </p>
          <Button data-testid="cta-section-button" onClick={onOpenContactForm} size="lg" className="bg-white text-[#FF1010] hover:bg-[#111827] hover:text-white font-black px-10 py-6 text-sm rounded-none uppercase tracking-widest btn-brutal">
            {buttonText} <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
